import React, { useState } from "react";
import { UncontrolledTooltip } from "reactstrap";
import DateTime from "luxon/src/datetime.js";

import { useHistory } from "react-router-dom";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
} from "reactstrap";

// Redux
import { useSelector } from "react-redux";

//components
import HeaderStatus from "./HeaderStatus";

//i18n
import { withTranslation } from "react-i18next";

const Header = ({ t }) => {
  const { mainTheme, headerName, version } = useSelector(
    (state) => state.Layout
  );
  const { indicators } = useSelector((state) => state.Header);

  const history = useHistory();

  const ligtStyle = {
    backgroundColor: "#556ee6",
    color: "white",
    width: "31px",
    height: "31px",
  };

  const darkStyle = {
    backgroundColor: "#31394F",
    color: "white",
    width: "31px",
    height: "31px",
  };
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);
  const showTitle =
    history.location.pathname === "/chats" ||
    history.location.pathname === "/manager-panel";

  return (
    <div className="w-100 navHeader d-flex flex-column">
      <Navbar color="faded" dark expand="xl" className="h-100 w-100">
        {showTitle && (
          <div className="m-0 text-muted flex-grow-1 mw-340">
            <h4 className="h-100 my-auto headerNameTitle">{t(headerName)}</h4>
            <p>v{version}</p>
          </div>
        )}
        {history.location.pathname === "/chats" && (
          <React.Fragment>
            <NavbarToggler
              onClick={toggle}
              style={{
                backgroundColor: "#222736",
                marginTop: "10px",
                marginBottom: "auto",
              }}
              className="text-warning"
            />
            <Collapse
              isOpen={isOpen}
              navbar
              style={{
                backgroundColor: mainTheme === "dark" ? "#262B3C" : "white",
                borderRadius: "1em",
                overflow: "hidden",
              }}
              className="h-100 py-1 flex-grow-0"
            >
              <Nav className="h-100" navbar>
                <NavItem
                  id="open-indicator"
                  style={{
                    borderLeft:
                      mainTheme === "dark"
                        ? "1px solid #323A4E"
                        : "1px solid #DFDFE1",
                  }}
                  className="text-nowrap d-flex justify-content-start"
                >
                  <NavLink
                    className="mr-1 d-flex"
                    style={{ display: "inline-block" }}
                  >
                    <HeaderStatus
                      fillcolor={mainTheme === "light" ? "#556ee6" : "#31394F"}
                      d="M11.038 2.28l-.002-.017-.003-.014c0-.005-.002-.01-.004-.014l-.005-.017-.006-.013c-.001-.005-.004-.009-.007-.014l-.009-.015-.007-.012-.01-.013-.006-.008-.005-.005-.01-.01-.005-.005L8.645.061c-.099-.088-.25-.08-.338.02-.088.098-.08.25.019.338l1.844 1.644H.24c-.133 0-.24.108-.24.24 0 .133.107.24.24.24h9.93L8.326 4.188h0c-.048.042-.076.101-.08.165-.004.063.018.126.06.174.042.047.102.076.166.08.063.003.126-.019.173-.061l2.315-2.064.004-.004.01-.01.005-.005.007-.008.01-.013.007-.012.01-.016.006-.013.005-.013c.003-.005.005-.011.006-.017l.004-.014.003-.014.002-.017.001-.017v-.006-.007l-.002-.016h0zM10.8 8.497H.87l1.844-1.645h0c.099-.088.107-.24.02-.338-.089-.1-.24-.108-.34-.02L.08 8.558c-.002 0-.003.003-.005.004l-.01.01-.004.005-.006.008-.01.013-.008.012-.009.015-.007.014-.005.013-.006.017-.004.014-.002.014L0 8.715v.016L0 8.737v.006l.001.017c0 .006.002.011.003.017l.002.013.004.015.006.017.005.013.007.013.009.016.008.011.01.013.006.009.005.004.01.01.005.005 2.314 2.063c.047.043.11.064.173.061.064-.004.124-.032.166-.08.042-.048.064-.11.06-.174-.004-.063-.032-.123-.08-.165L.87 8.977h9.93c.133 0 .24-.108.24-.24 0-.133-.107-.24-.24-.24h0z"
                      transform="translate(10 10)"
                      width="35"
                      style={mainTheme === "light" ? ligtStyle : darkStyle}
                      stroke="1.0"
                    />
                  </NavLink>
                  <NavLink style={{ display: "inline-block" }}>
                    <h5 className="text-muted">{t("Open")}</h5>
                    <h5>{indicators.open}</h5>
                  </NavLink>
                  <UncontrolledTooltip
                    placement="bottom"
                    target="open-indicator"
                    className="uncontrolledTooltip"
                  >
                    {t(
                      "Total number of open conversations. Sum of chats in progress, overdue and waiting"
                    )}
                  </UncontrolledTooltip>
                </NavItem>
                <NavItem
                  id="waiting-indicator"
                  style={{
                    borderLeft:
                      mainTheme === "dark"
                        ? "1px solid #323A4E"
                        : "1px solid #DFDFE1",
                  }}
                  className="text-nowrap d-flex justify-content-start"
                >
                  <NavLink
                    className="mr-1 d-flex"
                    style={{ display: "inline-block" }}
                  >
                    <HeaderStatus
                      fillcolor={mainTheme === "light" ? "#556ee6" : "#31394F"}
                      d="M20.793 22h-.13c-.659-.048-3.7-.465-4.616-3.419h-4.344C10.207 18.581 9 17.378 9 15.885v-4.173C8.984 10.204 10.191 9 11.687 9h7.61C20.793 9 22 10.204 22 11.696v4.173c0 1.268-.868 2.344-2.091 2.632.112 1.974.499 2.728.836 2.76h.032c.21 0 .37.177.354.37.032.208-.129.369-.338.369h0zM11.687 9.739c-1.094 0-1.962.882-1.962 1.957v4.173c0 1.092.885 1.958 1.962 1.958h4.634c.177 0 .322.112.354.273.466 1.877 1.93 2.632 2.976 2.953-.274-.642-.434-1.589-.483-2.857 0-.193.145-.353.338-.385 1.014-.097 1.77-.947 1.77-1.958V11.68c0-1.091-.885-1.958-1.963-1.958h-7.626v.017z"
                      style={mainTheme === "light" ? ligtStyle : darkStyle}
                    />
                  </NavLink>
                  <NavLink style={{ display: "inline-block" }}>
                    <h5 className="text-muted">{t("Waiting")}</h5>
                    <h5>{indicators.waiting}</h5>
                  </NavLink>
                  <UncontrolledTooltip
                    placement="bottom"
                    target="waiting-indicator"
                    className="uncontrolledTooltip"
                  >
                    {t(
                      "Number of open conversations waiting for consumer response (active and inactive chats)"
                    )}
                  </UncontrolledTooltip>
                </NavItem>
                <NavItem
                  id="overdue-indicator"
                  style={{
                    borderLeft:
                      mainTheme === "dark"
                        ? "1px solid #323A4E"
                        : "1px solid #DFDFE1",
                  }}
                  className="text-nowrap d-flex justify-content-start"
                >
                  <NavLink
                    className="mr-1 d-flex"
                    style={{ display: "inline-block" }}
                  >
                    <HeaderStatus
                      fillcolor={mainTheme === "light" ? "#556ee6" : "#31394F"}
                      d="M10.664 1.112C10.32.517 9.687.15 9 .15c-.687 0-1.32.366-1.664.96L.26 13.368c-.343.595-.343 1.327 0 1.921.344.595.978.961 1.664.961h14.152c.686 0 1.32-.366 1.664-.96.343-.595.343-1.327 0-1.922L10.664 1.112zm6.037 13.576c-.128.225-.367.364-.625.361H1.924c-.258 0-.496-.137-.625-.36-.128-.223-.128-.498 0-.722L8.375 1.712c.129-.224.367-.361.625-.361s.496.137.625.36l7.076 12.256c.131.223.131.499 0 .721z"
                      transform="translate(8.9 6.2)"
                      done="M9 10.977c.331 0 .6-.268.6-.6V5.086c0-.331-.269-.6-.6-.6-.331 0-.6.269-.6.6v5.29c0 .333.269.6.6.6zM9 12.184c-.257 0-.488.154-.587.391-.098.238-.043.51.138.692.182.182.454.236.692.138.237-.098.392-.33.392-.587 0-.168-.067-.33-.186-.448-.12-.12-.28-.186-.449-.186h0z"
                      transformone="translate(8.9 6.2)"
                      width={35}
                      height={32}
                      style={mainTheme === "light" ? ligtStyle : darkStyle}
                    />
                  </NavLink>
                  <NavLink style={{ display: "inline-block" }}>
                    <h5 className="text-muted">{t("Overdue")}</h5>
                    <h5>{indicators.overdue}</h5>
                  </NavLink>
                  <UncontrolledTooltip
                    placement="bottom"
                    target="overdue-indicator"
                    className="uncontrolledTooltip"
                  >
                    {t("Number of overdue conversations (with SLA exceeded)")}
                  </UncontrolledTooltip>
                </NavItem>
                <NavItem
                  id="bursting-indicator"
                  style={{
                    borderLeft:
                      mainTheme === "dark"
                        ? "1px solid #323A4E"
                        : "1px solid #DFDFE1",
                  }}
                  className="text-nowrap d-flex justify-content-start"
                >
                  <NavLink
                    className="mr-1 d-flex"
                    style={{ display: "inline-block" }}
                  >
                    <HeaderStatus
                      fillcolor={mainTheme === "light" ? "#556ee6" : "#31394F"}
                      d="M7.8.919c-2 0-3.997.76-5.518 2.282-3.043 3.043-3.043 7.998 0 11.04 3.042 3.044 7.996 3.044 11.038 0 .76-.76 1.333-1.642 1.714-2.582.382-.94.572-1.939.572-2.937V8.72c.006-.204-.072-.403-.215-.55-.142-.147-.338-.23-.542-.23-.205 0-.401.083-.544.23-.143.147-.22.346-.213.55 0 .806-.155 1.61-.461 2.368-.307.757-.767 1.466-1.382 2.082-2.464 2.463-6.434 2.463-8.897 0-2.463-2.464-2.463-6.436 0-8.9 2.463-2.463 6.433-2.463 8.897 0 .295.296.775.296 1.07 0 .296-.295.296-.775 0-1.07C11.8 1.678 9.8.917 7.8.917h0z"
                      transform="translate(8 7)"
                      done="M8.08 3.673c-.412.006-.742.374-.736.82v3.878c0 .446.334.808.747.809h4.014-.001c.413 0 .748-.363.748-.81 0-.447-.335-.809-.748-.809H8.839V4.494c.003-.22-.076-.43-.219-.585-.143-.154-.338-.24-.54-.237v.001zM14.132 0c-.244-.003-.476.105-.633.292-.158.188-.222.438-.177.679l.487 2.808-2.824-.253h0c-.448-.04-.843.292-.884.742-.04.45.291.848.739.889l3.88.348c.251.022.5-.074.671-.262.172-.187.247-.444.203-.694L14.925.69h.001c-.062-.394-.397-.685-.794-.69h0z"
                      transformone="translate(8 7)"
                      style={mainTheme === "light" ? ligtStyle : darkStyle}
                      stroke=".1"
                    />
                  </NavLink>
                  <NavLink style={{ display: "inline-block" }}>
                    <h5 className="text-muted">{t("Bursting")}</h5>
                    <h5>{indicators.bursting}</h5>
                  </NavLink>
                  <UncontrolledTooltip
                    placement="bottom"
                    target="bursting-indicator"
                    className="uncontrolledTooltip"
                  >
                    {t("Number of conversations with SLA close to expiration")}
                  </UncontrolledTooltip>
                </NavItem>
                <NavItem
                  id="csat-indicator"
                  style={{
                    borderLeft:
                      mainTheme === "dark"
                        ? "1px solid #323A4E"
                        : "1px solid #DFDFE1",
                  }}
                  className="text-nowrap d-flex justify-content-start"
                >
                  <NavLink
                    className="mr-1 d-flex"
                    style={{ display: "inline-block" }}
                  >
                    <HeaderStatus
                      fillcolor={mainTheme === "light" ? "#556ee6" : "#31394F"}
                      d="M11.223 21.999c-.079 0-.153-.032-.204-.09-.05-.059-.071-.136-.058-.212l.888-5.107-3.768-3.614h0c-.073-.068-.1-.171-.068-.265.03-.093.112-.162.211-.176l5.215-.746 2.33-4.646c.044-.088.135-.143.235-.143.099 0 .19.055.234.143l2.33 4.646 5.208.746c.099.014.18.083.211.176.031.094.005.197-.067.265l-3.768 3.614.887 5.11c.016.096-.023.194-.104.251-.081.058-.188.065-.276.02l-4.657-2.411-4.657 2.41c-.038.02-.08.03-.122.029h0zm4.78-2.989c.043 0 .085.011.122.032l4.31 2.23-.824-4.726c-.014-.084.014-.169.076-.227l3.486-3.356-4.812-.684c-.085-.012-.158-.066-.196-.141l-2.162-4.3-2.154 4.3c-.038.075-.112.129-.197.14l-4.82.69 3.486 3.356c.062.058.09.143.076.227l-.823 4.72 4.309-2.23h0c.038-.02.08-.03.122-.03h0z"
                      style={mainTheme === "light" ? ligtStyle : darkStyle}
                      stroke="0.9"
                    />
                  </NavLink>
                  <NavLink style={{ display: "inline-block" }}>
                    <h5 className="text-muted">{t("CSAT")}</h5>
                    <h5>{indicators?.csat?.csat ?? "-"}</h5>
                  </NavLink>
                  <UncontrolledTooltip
                    placement="bottom"
                    target="csat-indicator"
                    className="uncontrolledTooltip csatTooltip"
                  >
                    <div className="headerCsat">
                      <div className="title">
                        {t("Consumer Satisfaction Score")}
                        <span className="desc">
                          ({t("Total number of positive answers")} / <br />
                          {t("Total number of answers")})
                        </span>
                      </div>
                      <hr />
                      <Row className="info">
                        <Col sm="12">
                          <span className="leftItem">{t("Last update")}:</span>
                          {indicators?.csat?.lastUpdate
                            ? DateTime.fromJSDate(
                                indicators?.csat?.lastUpdate
                              ).toFormat("dd MMM yyyy HH'h'mm")
                            : "-"}
                        </Col>
                        <Col sm="12">
                          <span className="leftItem">
                            {t("KPI CSAT interval")}:
                          </span>
                          {indicators?.csat?.kpiCsat ?? "-"}
                        </Col>
                      </Row>
                    </div>
                  </UncontrolledTooltip>
                </NavItem>
                <NavItem
                  id="nps-indicator"
                  style={{
                    borderLeft:
                      mainTheme === "dark"
                        ? "1px solid #323A4E"
                        : "1px solid #DFDFE1",
                  }}
                  className="text-nowrap d-flex justify-content-start"
                >
                  <NavLink
                    className="mr-1 d-flex"
                    style={{ display: "inline-block" }}
                  >
                    <HeaderStatus
                      fillcolor={mainTheme === "light" ? "#556ee6" : "#31394F"}
                      d="M12 4C6.486 4 2 8.486 2 14a9.9 9.9 0 0 0 1.051 4.445c.17.34.516.555.895.555h16.107c.379 0 .726-.215.896-.555A9.9 9.9 0 0 0 22 14c0-5.514-4.486-10-10-10m7.41 13H4.59A7.9 7.9 0 0 1 4 14c0-4.411 3.589-8 8-8s8 3.589 8 8a7.9 7.9 0 0 1-.59 3 M10.939 12.939a1.53 1.53 0 0 0 0 2.561a1.53 1.53 0 0 0 2.121-.44l3.962-6.038a.03.03 0 0 0 0-.035a.033.033 0 0 0-.045-.01z"
                      style={mainTheme === "light" ? ligtStyle : darkStyle}
                      stroke="0.1"
                      transform="translate(4,3)"
                    />
                  </NavLink>
                  <NavLink style={{ display: "inline-block" }}>
                    <h5 className="text-muted">{t("NPS")}</h5>
                    <h5>{indicators?.nps?.nps ?? "-"}</h5>
                  </NavLink>
                  <UncontrolledTooltip
                    placement="bottom"
                    target="nps-indicator"
                    className="uncontrolledTooltip csatTooltip"
                  >
                    <div className="headerCsat">
                      <div className="title">
                        {/* //Adicionar logica da metrica */}
                        {t("Net promoter score index")}
                        <span className="desc">
                          ({t("Percentage of promoters")} - <br />
                          {t("Percentage of detractors")})
                        </span>
                      </div>
                      <hr />
                      <Row className="info">
                        <Col sm="12">
                          <span className="leftItem">{t("Last update")}:</span>
                          {indicators?.nps?.lastUpdate
                            ? DateTime.fromJSDate(
                                indicators?.nps?.lastUpdate
                              ).toFormat("dd MMM yyyy HH'h'mm")
                            : "-"}
                        </Col>
                        <Col sm="12">
                          <span className="leftItem">
                            {t("KPI NPS interval")}:
                          </span>
                          {indicators?.nps?.kpiNps ?? "-"}
                        </Col>
                      </Row>
                    </div>
                  </UncontrolledTooltip>
                </NavItem>
              </Nav>
            </Collapse>
          </React.Fragment>
        )}
      </Navbar>
      {!showTitle && <p>v{version}</p>}
    </div>
  );
};
export default withTranslation()(Header);
